import React from "react";
import { ApiActivitySelectionForActivityResponse } from "shared/types/ApiActivitySelectionForActivityResponse";
import { useShortlistParticipantService } from "../context";
import { useCopies } from "shared/hooks/useCopies";
import { fixedColumns, getColumns } from "../utils";
import { useOutletContext } from "react-router-dom";
import classNames from "classnames";
import { useStaticData } from "context/staticData";
import { getDynamicTableColumnForField } from "shared/core/Table/util";
import { Column } from "react-table";
import { TableOptionActionItems } from "shared/core/TableOptions";
import { TableNew } from "shared/core/Table/indexcopy";

export default function ShortlistParticipantsInActivityTable() {
  const service = useShortlistParticipantService();
  const copies = useCopies();
  const staticData = useStaticData();
  const tableRef = React.useRef<any>(null);
  const columns = React.useMemo(() => {
    const staticColumns = getColumns({
      copies,
      disabled: false,
      staticData,
      displayDietaryRequirements: service.selectedActivityDetails?.displayDietaryRequirements ?? false,
      activityAdminId: service.activityAdminId
    });
    const dynamicColumns = (service.dynamicColumnFieldsForPrioritization || [])?.map(item => {
      return getDynamicTableColumnForField({
        field: item,
        accessorPrefix: "prioritizationFieldValues",
        copies,
        currencyCode: service?.currencyCode,
        localeId: service?.localeId
      });
    });
    return [...staticColumns, ...dynamicColumns] as Array<Column<ApiActivitySelectionForActivityResponse>>;
  }, [
    copies,
    staticData,
    service.selectedActivityDetails,
    service.dynamicColumnFieldsForPrioritization,
    service.currencyCode,
    service.localeId,
    service.activityAdminId
  ]);

  const context: { filters?: Array<string> } = useOutletContext();
  const filteredData = React.useMemo(() => {
    if (!context.filters || context.filters.length === 0) {
      return service.data;
    }
    return service.data?.filter(
      item => context.filters?.includes(item.status) || context.filters?.includes(item.level)
    );
  }, [service.data, context.filters]);

  return (
    <div className={classNames("apShortlist--myExp_table", { noRecordsFound: filteredData.length === 0 })}>
      <TableOptionActionItems
        hasFullScreenIcon={false}
        hasRefreshIcon={false}
        hasManageColumnSelector={true}
        tableRef={tableRef}
      />
      <TableNew<ApiActivitySelectionForActivityResponse>
        name={"activity-shortlist"}
        data={filteredData ?? []}
        fixedColumns={fixedColumns}
        columns={columns}
        tableRef={tableRef}
        optionsHeight={0}
        additionalRowClassName="activityShortlistTableRow"
      />
    </div>
  );
}
